import { render } from "./HapiacaProfile.vue?vue&type=template&id=ecf641ee&scoped=true&ts=true"
import script from "./HapiacaProfile.vue?vue&type=script&lang=ts"
export * from "./HapiacaProfile.vue?vue&type=script&lang=ts"

import "./HapiacaProfile.vue?vue&type=style&index=0&id=ecf641ee&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src845797062/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf641ee"]])

export default __exports__